import React from 'react'
import { Skeleton } from '@mui/material'

export const TourStopSkeleton = () => {
  const rows = 10

  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton
          key={index}
          sx={{ mb: 0.5 }}
          height={48.5}
          animation='wave'
          variant='rounded'
        />
      ))}
    </>
  )
}
